import '../../utils/index.mjs';
import Popper from './src/popper2.mjs';
export { default as ElPopperArrow } from './src/arrow.mjs';
export { default as ElPopperTrigger } from './src/trigger.mjs';
export { default as ElPopperContent } from './src/content.mjs';
export { Effect, usePopperArrowProps, usePopperContentProps, usePopperCoreConfigProps, usePopperProps, usePopperTriggerProps } from './src/popper.mjs';
export { POPPER_CONTENT_INJECTION_KEY, POPPER_INJECTION_KEY } from './src/tokens.mjs';
export { useDeprecateAppendToBody } from './src/deprecation.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElPopper = withInstall(Popper);

export { ElPopper, ElPopper as default };
//# sourceMappingURL=index.mjs.map
